import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { LinkTarget } from '../../typings/common';
import { BannerImage } from '../../typings/domain';
import { GridBannerImage } from '../GridBannerImage/GridBannerImage';

import './GridBannerTextAdvCell.css';

export interface GridBannerTextAdvCellProps {
    id: string;
    title: string;
    titleExtension?: string;
    body?: string;
    domain?: string;
    href?: string;
    image?: BannerImage;
    column?: boolean;
    cls?: string;
    onClick?: () => void;
}
export class GridBannerTextAdvCell extends React.PureComponent<
    GridBannerTextAdvCellProps
> {
    render() {
        const {
            id,
            title,
            titleExtension,
            body,
            domain,
            href,
            image,
            column,
            onClick,
            cls
        } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: 'grid-banner-text-adv-cell',
                        mods: {
                            column: Boolean(column)
                        }
                    }),
                    cls
                )}
            >
                {image ? (
                    <GridBannerImage
                        cls={Bem.cls('grid-banner-text-adv-cell', 'image')}
                        image={image}
                        onClick={onClick}
                    />
                ) : (
                    undefined
                )}

                <div
                    className={Bem.cls('grid-banner-text-adv-cell', 'preview')}
                >
                    <h3
                        className={Bem.cls(
                            'grid-banner-text-adv-cell',
                            'title'
                        )}
                    >
                        <a
                            className={Bem.cls(
                                'grid-banner-text-adv-cell',
                                'title-link'
                            )}
                            href={href}
                            target={LinkTarget.blank}
                        >
                            {titleExtension
                                ? title + ' – ' + titleExtension
                                : title}
                        </a>
                    </h3>

                    <div
                        className={Bem.cls('grid-banner-text-adv-cell', 'body')}
                    >
                        {body}
                    </div>

                    <div
                        className={Bem.cls(
                            'grid-banner-text-adv-cell',
                            'domain'
                        )}
                    >
                        {domain}
                    </div>

                    {Boolean(id) && (
                        <div
                            className={classNames(
                                Bem.cls('grid-banner-text-adv-cell', 'id'),
                                TestBem.cls('grid-banner-text-adv-cell', 'id')
                            )}
                        >
                            № {id}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
